// PRD 11 §4.1 — Status / Publish Date cell.
//   PUBLISHED → green "게시중" badge with the YYYY.MM.DD date INSIDE the badge
//               (prototype `statusBadge`: `<span class="badge badge-success">게시중
//               ${publishedAt}</span>` — one badge, not a badge + a line below).
//   DRAFT     → neutral "임시저장" badge, no date.

import { useTranslation } from 'react-i18next';

import type { ConsultationManual } from '../types/counseling-manual.types';

interface ManualStatusBadgeProps {
  manual: Pick<ConsultationManual, 'status' | 'publishedAt'>;
}

export function ManualStatusBadge({ manual }: ManualStatusBadgeProps) {
  const { t } = useTranslation('counseling-manual');

  if (manual.status === 'PUBLISHED') {
    return (
      <span className="badge badge-success" style={{ whiteSpace: 'nowrap' }}>
        {manual.publishedAt ? `${t('statuses.published')} ${manual.publishedAt}` : t('statuses.published')}
      </span>
    );
  }

  return <span className="badge badge-secondary">{t('statuses.draft')}</span>;
}
